import { render, staticRenderFns } from "./MypageAboutUsingSection.vue?vue&type=template&id=4835914e&scoped=true"
import script from "./MypageAboutUsingSection.vue?vue&type=script&lang=ts"
export * from "./MypageAboutUsingSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageAboutUsingSection.vue?vue&type=style&index=0&id=4835914e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835914e",
  null
  
)

export default component.exports